import React, {Component} from 'react'

import CRUDManagerGenerator from '../generators/CRUDGenerator'
import {checkPermission, CAN_CREATE_PROJECT_ACTIVITIES, CAN_EDIT_PROJECT_ACTIVITIES} from "../../../lib/permissions";

const create = {
    table: 'project_activity_types',
    mutationType: 'upsert_',
    schema: {
        title: 'Create Project Activity',
        type: 'object',
        required: ['description'],
        properties: {
            description: {type: 'string', title: 'Description'}
        }
    }
}

const update = {
    table: 'project_activity_types',
    mutationType: 'upsert_',
    schema: {
        title: 'Update Project Activity',
        type: 'object',
        required: ['description'],
        properties: {
            project_activity_type_id: {type: 'integer'},
            description: {type: 'string', title: 'Description'}
        }
    },
    uiSchema: {
        project_activity_type_id: {"ui:widget": "hidden"},
    },
}

const read = {
    title: 'Project Activities',
    description: 'Project Activities allow you to define the areas of activity on a project.',
    table: 'project_activity_types',
    fields: ['project_activity_type_id', 'description'],
    uniqueKey: 'project_activity_type_id',
    columns: [
        {Header: 'ID', accessor: 'project_activity_type_id', maxWidth: '100'},
        {Header: 'Desc', accessor: 'description'}
    ]
}

const config = {
    create,
    read,
    update
}


const CRUDManager = CRUDManagerGenerator(config)

class ProjectActivities extends Component{

    render(){
        return (
            <CRUDManager
                canCreate={checkPermission(CAN_CREATE_PROJECT_ACTIVITIES)}
                canEdit={checkPermission(CAN_EDIT_PROJECT_ACTIVITIES)}
            />
        )
    }
}

export default ProjectActivities